import { createReducer, on } from '@ngrx/store';
import * as HealthActions from './health.actions';
import { HealthStatus } from '../../shared/services/health/health.service';

export interface HealthState {
  health: HealthStatus | null;
  loading: boolean;
  error: any;
  lastLoaded: number | null;
}

export const initialState: HealthState = {
  health: null,
  loading: false,
  error: null,
  lastLoaded: null,
};

export const reducer = createReducer(
  initialState,
  on(HealthActions.loadHealth, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(HealthActions.loadHealthSuccess, (state, { health }) => ({
    ...state,
    health,
    loading: false,
    error: null,
    lastLoaded: Date.now(),
  })),
  on(HealthActions.loadHealthFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(HealthActions.clearHealth, (state) => ({
    ...state,
    health: null,
    lastLoaded: null,
  })),
);
